import { STATUS } from "angular-in-memory-web-api"
import { ACTIONS } from "./actions.constant"

export const INPUT_VALIDATION_MESSAGES = {
  NAME: 'Invalid character entered. Please remove special characters (e.g., @;, #, <, >, %).',
}

export const TOOLTIP_DISCRIPTION_MESSAGES = {
  ACTIONS:{
    WRITEBACK_RETRY: 'Retry posting this transaction to PMS',
    WRITEBACK_SKIP: 'Skip posting this transaction to PMS',
    WRITEBACK_PROCEED: 'Proceed with posting this transaction to PMS',
    REFUND_SETTLEMENT: 'Refund / Settlement'
  },
  STATUS: {
    ORDER_CREATED: 'Order Created',
    ORDER_COMPLETED: 'Order Completed',
    ORDER_CANCELLED: 'Order Cancelled',
    PAYMENT_INITIATED: 'Payment Initiated',
    PAYMENT_SUCCESS: 'Payment Success',
    PAYMENT_FAILED: 'Payment Failed',
    WRITEBACK_PENDING: 'Writeback Pending',
    WRITEBACK_SUCCESS: 'Transaction has been successfully written in PMS',
    WRITEBACK_FAILED: 'Failed to Writeback this transaction in PMS, please check manually in PMS or contact technical support',
    WRITEBACK_DUPLICATE: 'Writeback Duplicate',
    WRITEBACK_SKIPPED: 'Writeback Skipped',
    ONBOARDING_MASTER_ACCOUNT_CREATED: 'Master Account Created',
    ONBOARDING_ORDER_CREATED: 'Order Created',
    ONBOARDING_TT_ACCOUNT_CREATED: 'TT Account Created',
    ONBOARDING_PRACTICE_ACTIVE: 'Practice Active',
    ONBOARDING_AGREEMENT_ACCEPTED: 'Agreement Accepted',
    ONBOARDING_CONFIGURED_PMS: 'Configured PMS',
    ONBOARDING_PROCESSOR_SETUP_COMPLETED: 'Processor Setup Completed',
    INVOICE_PAID: 'Invoice Paid',
    INVOICE_DUE: 'Invoice Due',
    INVOICE_OVERDUE: 'Invoice Overdue',
    INVOICE_VOIDED: 'Invoice Voided',
    INVOICE_REFUNDED: 'Invoice Refunded',
  }
}